export const getHtmlRenderer = (field: any) => {
  switch (field.type) {
    case 'text':
    case 'textarea':
    case 'email':
    case 'tel':
    case 'datepicker':
    case 'picker':
      return `
<p>{{${field.name}Label}}</p>
<p>{{${field.name}Description}}</p>
<p>{{${field.name}}}</p>`;
    case 'robeSizes':
      return `
<table>
  <tbody>
    <tr>
        <td>Înălțimea absolventului</td>
        <td>sub 1,66m</td>
        <td>între 1,67 și 1,71m</td>
        <td>între 1,72 și 1,80m</td>
        <td>între 1,81 și 1,85m</td>
        <td>peste 1,85m</td>
    </tr>
    <tr>
        <td>Măsura robei recomandată</td>
        <td>XS</td>
        <td>S</td>
        <td>M</td>
        <td>L</td>
        <td>XL</td>
    </tr>
    <tr>
        <td>Necesar robe pentru elevi</td>
        <td><strong>{{${field.name}.xs}}</strong></td>
        <td><strong>{{${field.name}.s}}</strong></td>
        <td><strong>{{${field.name}.m}}</strong></td>
        <td><strong>{{${field.name}.l}}</strong></td>
        <td><strong>{{${field.name}.xl}}</strong></td>
    </tr>
    <tr>
        <td>Măsură robă diriginte</td>
        <td><strong>{{${field.name}.classMasterXS}}</strong></td>
        <td><strong>{{${field.name}.classMasterS}}</strong></td>
        <td><strong>{{${field.name}.classMasterM}}</strong></td>
        <td><strong>{{${field.name}.classMasterL}}</strong></td>
        <td><strong>{{${field.name}.classMasterXL}}</strong></td>
    </tr>
    <tr>
        <td colspan="5">Total necesar robe (elevi + diriginte)</td>
        <td><strong>{{sumKeys marimiRobe "xs" "s" "m" "l" "xl" "classMasterXS" "classMasterS" "classMasterM" "classMasterL" "classMasterXL"}}</strong></td>
    </tr>
  </tbody>
</table>
`;
    case 'products':
      return `
<table>
  <tbody>
    <tr>
      <td>Denumirea pachetului / produsului</td>
      <td>Cantitate (elevi)</td>
      <td>Preț unitar (RON/elev)</td>
      <td>Valoare</td>
    </tr>
    {{#each ${field.name}}}
      <tr>
        <td>{{name}}</td>
        <td>{{quantity}}</td>
        <td>{{price}} RON</td>
        <td>{{multiply price quantity}} RON</td>
      </tr>
    {{/each}}
    <tr>
      <td colspan="3">Total de plată</td>
      <td><strong>{{sumTotals ${field.name} "price * quantity"}} RON</strong></td>
    </tr>
  </tbody>
</table>
      `;
    case 'disclaimer':
      return `
<p>{{${field.name}Title}}</p>
<p>{{${field.name}Description}}</p>
`;
    case 'checkboxGroup':
      return `
<p>{{${field.name}Label}}</p>
<p>{{${field.name}Description}}</p>
<ul>
  {{#each ${field.name}}}
    <li>{{ this }}</li>
  {{/each}}
</ul>
`;
    case 'radioButtonGroup':
      return `
<p>{{${field.name}Label}}</p>
<p>{{${field.name}Description}}</p>
<p>{{${field.name}}}</p>
`;
    case 'imagePicker':
      return `
<p>{{${field.name}Label}}</p>
<p>{{${field.name}Description}}</p>
<ul>
  {{#each ${field.name}}}
    <li>{{ this }}</li>
  {{/each}}
</ul>
`;
    case 'map':
      return `
<p>{{${field.name}Label}}</p>
<p>{{${field.name}Description}}</p>
<a href='https://waze.com/ul?ll={{${field.name}.lat}},{{${field.name}.lng}}&navigate=yes' target='_blank'>Open in Waze</a>
`;
    case 'title':
      return `<h1>{{${field.name}Title}}</h1>`;
    case 'signature':
      return `
<svg xmlns="http://www.w3.org/2000/svg" width="300" height="150" viewBox="0 0 300 150">
  <rect id="r" width="300" height="150" fill="transparent" />
  <path d="{{${field.name}}}" stroke="navy" stroke-width="2" fill="none" pointerEvents="none" />
</svg>
`;
    case 'multi-level-combobox':
      return `
${Object.keys(field.customInput.selectedValues)
  .map((key: string) => `<p>{{${field.name}.${key}}}</p>`)
  .join('\n')}
${Object.keys(field.customInput.properties)
  .map((key: string) => `<p>{{${field.name}.${key}}}</p>`)
  .join('\n')}
`;
    default:
      return null;
  }
};
